import { BaseControl } from "@cloudpivot/form/src/common/controls/base-control";
// import { ControlHelper } from './control-helper';
import { DataItemType, DispalyMode, ListDispalyMode } from '@cloudpivot/form/schema';
// import { FormControlValueService } from '../services';
export class ReverseRelevanceControl extends BaseControl {
    get isShow() {
        return this.controlOpts.listDisplayMode === ListDispalyMode.Table;
    }
    get isTabs() {
        return this.controlOpts.listDisplayMode === ListDispalyMode.Tabs;
    }
    get isList() {
        return this.controlOpts.displayMode === DispalyMode.List;
    }
    get isLink() {
        return this.controlOpts.displayMode === DispalyMode.Link;
    }
    get sequenceStatus() {
        let value = '';
        const val = this.controlOpts.sheetParams;
        if (val && val.sequenceStatus) {
            value = val.sequenceStatus;
        }
        return value;
    }
    get field() {
        let value = '';
        const val = this.controlOpts.sheetParams;
        if (val && val.id) {
            value = val.id;
        }
        return {
            code: this.controlOpts.fieldCode,
            // @ts-ignore
            type: Number(this.controlOpts.relativeType) || DataItemType.RelevanceForm,
            value
        };
    }
    get query() {
        return [this.field];
    }
    get currentFormId() {
        let id = '';
        const val = this.controlOpts.sheetParams;
        if (val && val.id) {
            id = val.id;
        }
        return id;
    }
    get currentSheetId() {
        let id = '';
        const val = this.controlOpts.sheetParams;
        if (val && val.sheetid) {
            id = val.sheetid;
        }
        return id;
    }
    get selfFormCode() {
        const val = this.controlOpts.sheetParams;
        if (val && val.formCode) {
            return val.formCode;
        }
        return '';
    }
    get selfSchemaCode() {
        const val = this.controlOpts.sheetParams;
        // const val = this.ctrl.value;
        if (val && val.schemaCode) {
            return val.schemaCode;
        }
        return '';
    }
    getAll(queryParam) {
        let query = [];
        if (queryParam) {
            query = query.concat(queryParam);
            query = query.map((x) => {
                let val = null;
                if (x.value || x.value === false) {
                    val = x.value;
                }
                else {
                    val = x.propertyValue;
                }
                if ((x.type || x.type === 0) && (x.value || x.value === false)) {
                    switch (x.type) {
                        case DataItemType.RelevanceForm:
                            val = x.value.id || '';
                            break;
                        case DataItemType.StaffSingle:
                        case DataItemType.StaffMulti:
                        case DataItemType.StaffDeptMix:
                        case DataItemType.DeptMulti:
                        case DataItemType.DeptSingle:
                            val = x.value.map((v) => ({
                                id: v.id,
                                type: v.unitType || v.type
                            }));
                            val = JSON.stringify(val);
                            break;
                        case DataItemType.Logic:
                            break;
                        default:
                            if (Array.isArray(x.value)) {
                                val = x.value.map(v => v.toString()).join(';');
                            }
                            else {
                                val = x.value;
                            }
                            break;
                    }
                }
                return ({
                    code: x.code,
                    type: x.type,
                    value: val
                });
            });
        }
        query.push(this.field);
        const schemaCode = this.controlOpts.schemaCode;
        return ReverseRelevanceControl.service.getAll(schemaCode, this.id, this.selfSchemaCode, this.selfFormCode, query);
    }
    open(item) {
        if (this.isLink || this.isTabs) {
            ReverseRelevanceControl.service.open(this.controlOpts.schemaCode, item);
        }
    }
    fetch(page, pageSize, value, queryData) {
        // if (!RelevanceFormControl.service) {
        //     return;
        // }
        const schemaCode = this.controlOpts.schemaCode || '';
        const queryCode = this.controlOpts.listCode || '';
        // if (!schemaCode || !queryCode) {
        //     return;
        // }
        let params = queryData;
        params.push({
            code: 'name',
            type: DataItemType.ShortText,
            value
        });
        if (this.field) {
            // params = params.filter(res => res.code !== this.controlOpts.fieldCode);
            params.push(this.field);
        }
        const _ctrl = this.ctrl;
        const cols = _ctrl.options && _ctrl.options.mappings ? Object.keys(_ctrl.options.mappings) : [];
        return ReverseRelevanceControl.service.search(schemaCode, this.selfSchemaCode, this.id, this.selfFormCode, params, cols, page, pageSize, queryData);
        // return ReverseRelevanceControl.service.search(schemaCode, queryCode, params, cols, page, pageSize, queryData);
    }
}
// export interface RelevanceFormSearchParams {
//     code: string
//     type: DataItemType
//     value: any
// }
// export interface RelevanceFormSearchResult {
//     id: string
//     name: string
//     [key: string]: any
// }
// export interface Segment<T> {
//     total: number
//     data: T[]
// }
